{
  "appname": "Quotes App",
  "deletionAppName": "Quotes App",
  "mail": "{'support@motivationalquotes.me'}",
  "getTheApp": "Hol dir die Quotes App!",
  "home-header": "Die besten Sprüche!",
  "home-subheader": "Schicke Liebe, Inspiration, Glückwünsche & Weisheiten für jede Lebenslage in WhatsApp, auf Instagram, Facebook Messenger und auf allen anderen Plattformen.",
  "dataprotection_header_web": "Datenschutzerklärung von Quotes App (Web Version)",
  "dataprotection_header_app": "Datenschutzerklärung von Quotes App"
}
